const initialState = {
	list: [],
	page: 1,
	isListNext: false,
	scrollPos: 0,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'PAYMENT_TICKET_SENDER_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.scrollPos = 0;
		return newState;
	}
	else {
		return state;
	}
}
